import { useEffect, useRef, useState } from "react";
import { CirclePicker, GithubPicker } from "react-color";

import { useTranslation } from "react-i18next";

import { useSpring, animated, config } from "@react-spring/web";

import { useMultiuserContext } from "@solidwhite/multiuser";
import { useSnapshot } from "valtio";
import store from "../../../appStore";
import SessionEndScreen from "./SessionEndScreen";
import Logo from "../../ui/HeaderBar/Logo";

import "./joinmenu.css";
import LanguageMenu from "../../ui/HeaderBar/LanguageMenu";

const colors = ["#3f97b5", "#f2c14e", "#e9685d", "#5D74E9", "#AC5DE9"];

const SpectatorJoinMenu = () => {
  const { connected, presenting, spectating } = useMultiuserContext();
  const { multiuser, datastoreReady, loadingFinished } = useSnapshot(store);
  const { nameEntered } = multiuser;
  const { t } = useTranslation();

  if (!datastoreReady || !loadingFinished) {
    return null;
  }

  if (!connected && spectating) {
    return <SessionEndScreen />;
  }

  if (!connected || presenting) return null;

  if (connected && spectating && nameEntered)
    return (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,

          width: "100%",
          height: "100%",
          zIndex: 9999998,
          // background: "black",
          pointerEvents: "auto",
        }}
      ></div>
    );
  return <SpectatorJoinMenuSub />;
};

const SpectatorJoinMenuSub = ({ ...props }) => {
  const inputref = useRef();
  const { awareness } = useMultiuserContext();
  const { t } = useTranslation();

  const [color, setcolor] = useState({
    hex: colors[Math.floor(Math.random() * colors.length)],
  });

  useEffect(() => {
    awareness.setLocalStateField("color", color.hex);
  }, [color]);

  const handleSubmit = () => {
    if (inputref.current.value) {
      awareness.setLocalStateField("name", inputref.current.value);
      awareness.setLocalStateField("color", color.hex);
      store.multiuser.nameEntered = true;
    }
  };

  const handleInputKeyUp = (evt) => {
    if (evt.key == "Enter") {
      handleSubmit();
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        zIndex: 9999999999998,
        background: "black",
        color: "white",
      }}
    >
      <Logo />
      <div style={{ height: "48px" }}></div>

      <h2
        style={{
          margin: 0,
          fontSize: "21px",
          fontWeight: "medium",
        }}
      >
        {t("MULTIUSER_READY")}
      </h2>

      <Seperator />

      <p style={{ margin: 0, marginBottom: "24px", fontSize: "16px" }}>{t("MULTIUSER_NAME")}</p>

      <input
        type="text"
        className="black-box"
        id="join-input"
        onSubmit={handleSubmit}
        onKeyUp={handleInputKeyUp}
        ref={inputref}
        maxLength={25}
      ></input>

      <Seperator />

      <p style={{ margin: 0, marginBottom: "6px", fontSize: "16px" }}>{t("MULTIUSER_COLOR")}</p>
      <div style={{ marginBottom: "0px", marginTop: "14px" }}>
        <CirclePicker
          color={color}
          onChange={(c) => setcolor(c)}
          colors={colors}
          styles={{ marginBottom: "5rem" }}
          width={"auto"}
        />
      </div>

      <Seperator />

      <LanguageMenu />

      <Seperator />

      <Button textId="MULTIUSER_JOIN" onClick={handleSubmit} margin={false}></Button>

      <div style={{ height: "48px" }}></div>

      <MouseIcon />
      <div style={{ height: "12px" }}></div>
      <p
        style={{
          width: "450px",
          fontWeight: 300,
          color: "#A7A7A7",
          textAlign: "center",
          fontSize: "12px",
          lineHeight: "18px",
        }}
      >
        {t("MULTIUSER_JOIN_TUTORIAL")}
      </p>
    </div>
  );
};

export const Button = ({ textId = "button", onClick = () => {}, ...props }) => {
  const { t } = useTranslation();

  const [hovered, setHovered] = useState(false);

  const { backgroundColor } = useSpring({
    backgroundColor: hovered ? "#5cd89a" : "#37a46e",
    config: config.stiff,
  });

  return (
    <animated.div
      onClick={(e) => {
        onClick(e);
      }}
      style={{
        color: "#000",
        textAlign: "center",
        width: "max-content",
        fontSize: "18px",
        fontWeight: 500,
        padding: "11px",
        paddingLeft: "20px",
        paddingRight: "20px",
        // paddingTop: "11px",
        // paddingBottom: "11px",
        pointerEvents: "auto",
        transition: "boxShadow 0.9s linear",
        borderRadius: "3px",
        cursor: "pointer",
        opacity: 1,
        backgroundColor: backgroundColor,
        display: "flex",
        alignItems: "center",
        minWidth: "60px",
        display: "flex",
        justifyContent: "center",
      }}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
    >
      {t(textId)}
    </animated.div>
  );
};

const MouseIcon = () => {
  return (
    <svg width="22" height="34" viewBox="0 0 22 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 11.5H11V1.5H9L4 3.5L1.5 7.5L1 11.5Z" fill="#37A46E" />
      <rect x="1" y="1" width="20" height="32" rx="9.5" stroke="white" strokeWidth="2" />
      <path d="M11 9L11 13" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export const Seperator = () => {
  return (
    <div
      style={{
        width: "50px",
        height: "2px",
        backgroundColor: "white",
        marginTop: "24px",
        marginBottom: "24px",
      }}
    ></div>
  );
};

export default SpectatorJoinMenu;
